(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseNumberingRow', PurchaseNumberingRow);

    PurchaseNumberingRow.$inject = ['$resource'];

    function PurchaseNumberingRow ($resource) {
        var resourceUrl =  'api/purchase-numbering-rows/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
